<template>
	<div>
		<!-- 用户详情 -->
		<el-dialog
			:title="form.User.UserName"
			:visible.sync="isDialogVisible"
			:modal="false"
			:close-on-click-modal="false"
			:close-on-press-escape="true"
			:before-close="handleConfirm"
			width="50%"
			v-if="isDialogVisible"
		>
			<el-tabs v-model="activeName">
				<el-tab-pane label="用户详情" name="first">
					<el-scrollbar style="height: 400px" ref="scrollbar">
					<el-form :model="form.User" style="padding:10px">
						<el-form-item label="用户名:" laber-width="120px"><span>{{form.User.UserName}}</span></el-form-item>
						<el-form-item label="用户类型:" laber-width="120px"><span>{{form.User.UserType}}</span></el-form-item>
						<el-form-item label="手机号:" laber-width="120px">
							<span v-if="!isEditPhone">{{form.User.Phone}}</span>
							<el-input v-model="editPhone" size="mini" style="width: 140px;" v-if="isEditPhone"></el-input>
							<el-button size="mini" type="success" style="margin-left: 10px;" v-if="isEditPhone" @click="setPhone">确定</el-button>
							<el-button size="mini" style="margin-left: 10px;" @click="isEditPhone = false" v-if="isEditPhone">取消</el-button>
							<el-button size="mini" type="success" style="margin-left: 10px;" v-if="!isEditPhone" @click="isEditPhone = true">修改手机号码</el-button>
						</el-form-item>
						<el-form-item label="身份证号:" laber-width="120px"><span>{{form.User.UniqueID}}</span></el-form-item>
						<el-form-item label="地址:" laber-width="120px"><span>{{form.User.Address}}</span></el-form-item>
						<el-form-item label="是否已实名:" laber-width="120px">
							<el-tag type="success" v-if="form.User.IsRealName">已实名</el-tag>
							<el-tag type="warning" v-else>未实名</el-tag>
						</el-form-item>
						<el-form-item label="身份证照(前):" laber-width="120px">
							<!-- <div v-if="form.User.IDCardImageTops&&form.User.IDCardImageTops.SmallPath">
								<img :src="$store.state.imgUrl + form.User.IDCardImageTops.Id" class="avatar">
							</div> -->
							<showImages v-if="form.User.IDCardImageTops2&&form.User.IDCardImageTops2.length>0" :imgs="form.User.IDCardTops" :ids="form.User.IDCardImageTops2"></showImages>
						</el-form-item>
						<el-form-item label="身份证照(后):" laber-width="120px">
							<!-- <div v-if="form.User.IDCardImageAfters&&form.User.IDCardImageAfters.SmallPath">
								<img :src="$store.state.imgUrl + form.User.IDCardImageAfters.Id" class="avatar">
							</div> -->
							<showImages v-if="form.User.IDCardImageAfters2&&form.User.IDCardImageAfters2.length>0" :imgs="form.User.IDCardAfters" :ids="form.User.IDCardImageAfters2"></showImages>
						</el-form-item>
					</el-form>
					</el-scrollbar>
				</el-tab-pane>
				<el-tab-pane label="采伐者详情" name="second">
					<el-table :data="form.Fell" height="400px" align="center" v-if="form.Fell.length > 0">
						<el-table-column type="index" label="序号" width="80"></el-table-column>
						<el-table-column prop="Name" label="姓名/公司名"></el-table-column>
						<el-table-column prop="Address" label="地址"></el-table-column>
						<el-table-column prop="State" label="状态">
							<template slot-scope="scope">
								<el-tag type="warning" v-if="scope.row.State == 0">审核中</el-tag>
								<el-tag type="success" v-if="scope.row.State == 1">通过审核</el-tag>
								<el-tag type="danger" v-else>未通过审核</el-tag>
							</template>
						</el-table-column>
						<!-- <el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="goDetail(1)">详情</el-button>
							</template>
						</el-table-column> -->
					</el-table>
					<el-empty description="暂无数据" v-else></el-empty>
				</el-tab-pane>
				<el-tab-pane label="加工厂/集材厂" name="third">
					<el-table :data="form.Fac" height="400px" align="center" v-if="form.Fac.length > 0">
						<el-table-column type="index" label="序号" width="80"></el-table-column>
						<el-table-column prop="Name" label="厂名"></el-table-column>
						<el-table-column prop="IDCard" label="身份证/机构代码"></el-table-column>
						<el-table-column prop="Corporation" label="法人"></el-table-column>
						<el-table-column prop="Type" label="类型">
							<template slot-scope="scope">
								<span  v-if="scope.row.Type == 1">集材厂</span>
								<span  v-else>加工厂</span>
							</template>
						</el-table-column>
						<el-table-column prop="Address" label="经营地址"></el-table-column>
						<el-table-column prop="State" label="状态">
							<template slot-scope="scope">
								<el-tag type="warning" v-if="scope.row.State == 0">审核中</el-tag>
								<el-tag type="success" v-if="scope.row.State == 1">通过审核</el-tag>
								<el-tag type="danger" v-else>未通过审核</el-tag>
							</template>
						</el-table-column>
						<!-- <el-table-column label="操作">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="goDetail(2)">详情</el-button>
							</template>
						</el-table-column> -->
					</el-table>
					<el-empty description="暂无数据" v-else></el-empty>
				</el-tab-pane>
			</el-tabs>
			<span slot="footer" class="dialog-footer">
				<el-button type="success" @click="handleConfirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import showImages from '@/components/showImage'
import { SetAssociatedPhone } from '@/api/user.js'
export default {
	name: 'Dialog',
	props: {
		/* 对话框是否可见 */
		isDialogVisible: {
			type: Boolean,
			default: false
		},
		/* 数据 */
		form: {
			type: Object
		}
	},
	watch: {
		isDialogVisible() {
			this.isEditPhone = false
		},
		form(val) {
			this.editPhone = val.User.Phone
		}
	},
	components:{showImages},
	data() {
		return {
			activeName: 'first',
			editPhone: this.form.User.Phone,
			isEditPhone: false
		};
	},
	methods: {
		handleConfirm() {
			this.activeName = 'first';
			this.$emit('dialog-Confirm');
		},
		goDetail(type){
			if(type==1){
				this.$router.push({ path:'/fell/fellAreaManage'})
			}else{
				this.$router.push({ path:'/operateManage/facs'})
			}
		},
		// 确定修改手机号码
		setPhone() {
			if(this.editPhone == "") {
				this.$message.warning("请填写手机号码")
				return
			}
			let params = {
				userCode: this.form.User.UserCode,
				phone: this.editPhone
			}
			SetAssociatedPhone(params).then(res => {
				if(res.data.state == 1) {
					this.$message.success("修改成功")
					this.isEditPhone = false
					this.form.User.Phone = this.editPhone
				}
			})
		}
	}
};
</script>

<style lang="less" scoped>
	.avatar {
		width: 50px;
		height: 50px;
	}
</style>
